import React, { useEffect, useRef, useState } from 'react';
import { Skeleton, Grid } from 'antd';

const { useBreakpoint } = Grid;

const StripePricingTable = ({ customerEmail }) => {
  const scriptRef = useRef(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const screens = useBreakpoint();

  useEffect(() => {
    // Check if the script is already loaded
    if (document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]')) {
      setScriptLoaded(true);
      return;
    }

    // Load the Stripe pricing table script
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/pricing-table.js';
    script.async = true;
    
    script.onload = () => {
      setScriptLoaded(true);
    };
    
    scriptRef.current = script;
    document.head.appendChild(script);

    // Cleanup function to remove the script when component unmounts
    return () => {
      if (scriptRef.current && document.head.contains(scriptRef.current)) {
        document.head.removeChild(scriptRef.current);
      }
    };
  }, []);

  // Check if environment variables are loaded
  const stripePricingTableId = process.env.REACT_APP_STRIPE_PRICING_TABLE_ID;
  const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

  // Debug logging
  console.log('Stripe config:', {
    pricingTableId: stripePricingTableId,
    publishableKey: stripePublishableKey,
    customerEmail
  });

  // Show loading if script is not loaded or if environment variables are missing
  const isLoading = !scriptLoaded;

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px',
        padding: screens.md ? '40px' : '20px'
      }}>
        <div style={{ width: '100%', maxWidth: '600px' }}>
          <Skeleton active paragraph={{ rows: 6 }} />
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '400px',
      padding: screens.md ? '40px' : '20px',
      backgroundColor: 'white',
      borderRadius: '12px',
      margin: screens.md ? '20px' : '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    }}>
      <stripe-pricing-table
        key="with-customer-email"
        pricing-table-id={stripePricingTableId}
        publishable-key={stripePublishableKey}
        customer-email={customerEmail}
      />
    </div>
  );
};

export default StripePricingTable; 